import { render, staticRenderFns } from "./weingut-forstmeister-geltz-zilliken.vue?vue&type=template&id=e6171706&scoped=true"
import script from "./weingut-forstmeister-geltz-zilliken.vue?vue&type=script&lang=js"
export * from "./weingut-forstmeister-geltz-zilliken.vue?vue&type=script&lang=js"
import style0 from "./weingut-forstmeister-geltz-zilliken.vue?vue&type=style&index=0&id=e6171706&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6171706",
  null
  
)

export default component.exports